<script setup lang="ts">
import type { GameItem } from '@kira-dancer/nuxt-common'
import { useTopJackpot } from '~/composables/top-jackpot/use-top-jackpot'
import { HOME_SWIPER_OPTIONS } from '~/resources'

const { jackpotGameSorting, handlePlayingGame, gameJackpotTopOne } =
  useTopJackpot()
const isSwiperLoaded = ref(false)

const swiperOptions = {
  ...HOME_SWIPER_OPTIONS,
  loop: false,
  slidesPerView: 2.42,
  spaceBetween: 12,
}

const onSwiper = () => {
  isSwiperLoaded.value = true
}
</script>

<template>
  <div v-if="jackpotGameSorting?.length" class="top-jackpot-mb">
    <div class="supper-jackpot">
      <div
        class="supper-jackpot__overlay"
        @click="handlePlayingGame(gameJackpotTopOne)"
      />

      <div class="bg-supper-jackpot">
        <div class="bg-supper-jackpot-crown">
          <img
            src="/images/home/top-jackpot/bg-supper-jackpot-crown-mb.webp"
            alt="crown"
            loading="lazy"
          />
        </div>

        <div class="bg-supper-jackpot-banner">
          <img
            src="/images/home/top-jackpot/bg-supper-jackpot-mb.webp"
            alt="bg supper jackpot"
            loading="lazy"
          />
        </div>
      </div>

      <div class="supper-jackpot__item">
        <CommonGameItem
          :is-hide-jackpot-number="true"
          :is-hide-effect-hover="true"
          :item="gameJackpotTopOne"
        />
      </div>
      <div class="wrap-supper-jackpot-number">
        <div
          v-if="gameJackpotTopOne?.jackpotNumber"
          class="supper-jackpot__number"
        >
          <BaseAnimatedNumber
            :number="gameJackpotTopOne?.jackpotNumber"
            :start="gameJackpotTopOne?.jackpotNumber"
          />
        </div>
      </div>
    </div>

    <div class="jackpots">
      <BaseSwiper
        v-show="isSwiperLoaded"
        :items="jackpotGameSorting.slice(1)"
        :options="swiperOptions"
        :on-swiper="onSwiper"
      >
        <template #item="{ item }: { item: GameItem }">
          <CommonGameItem :item="item" />
        </template>
      </BaseSwiper>

      <div
        v-show="!isSwiperLoaded"
        class="recent-game-section__placeholder-games"
      >
        <CommonGameItem
          v-for="item in jackpotGameSorting.slice(0, 3)"
          :key="item.ID"
          :item="item"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/mobile/home/top-jackpot.scss';
</style>
